import React, { useEffect, useState } from "react";
import generalHelper from "../utils/generalHelper.js";
import variable_styles from "../../assets/variables.json";
import IconArrow from "../../assets/images/IconArrow"

import Inputfield from "../customComponents/Inputfield";
import Button from "../customComponents/Button";
import Checkbox from "../customComponents/Checkbox";

import styles from "../../assets/stylesheets/Screen.module.css";
import login_styles from "../../assets/stylesheets/sass/Login.module.scss";

// import Inputfield from './Input';
import FormLoader from './FormLoader';
import FormError from './FormError';

import content from "../../assets/content/content.json";
import { ReactSession }  from 'react-client-session';
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast'
import localforage from "localforage";
import { setCookie } from 'src/lib/cookies';
import { getFitdocTokenByRole } from '../../components/utils/utils';
import { useDispatch } from "react-redux";
import { setUserData } from "../../redux/actions/index.js";

let rememberMe = false;
let email_global = "";
let password_global = "";
export default function LoginForm({title, typeLogin, loggedInLogin}){
	const [content_state, setcontent_state] = useState({});
	const [error, seterror] = useState({});
	const dispatch = useDispatch();
	useEffect(()=>{
		const fetchData = async () =>{
			try {
				const data = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
				let res = await data.json();
				setcontent_state(res);
			} catch (error) {
				if(error.message === 'Failed to fetch'){
					navigate('/maintenance')
				}
			}
        }
        fetchData();
	}, [])

	const [loggedIn, setLoggedIn] = useState(false);

	const emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');

	const [emailPWForgot, setemailPWForgot] = useState('');

	const [showLoader, setShowLoader] = useState(false);
	const [showError, setShowError] = useState(false);
	const [showEmailSent, setShowEmailSent] = useState(false);
	
	const [showPasswordForgot, setshowPasswordForgot] = useState(false);

	const [white_overlay, setwhite_overlay] = useState(false);
	const [white_overlayLR, setwhite_overlayLR] = useState(false);

	const navigate = useNavigate();
	
	const [transClasses, setTransClasses] = useState('');
	let transitionClassesParsed;

	const handleAuthenticateuser = (userdata) =>{
		fetch(process.env.REACT_APP_SERVER_LINK+"login", {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(userdata)
				}).then(
					res => res.json()
				).then(
					data => {
					if(data.errorcode === 0){
						localforage.clear();
						ReactSession.set("language", data.object.language);
						if(rememberMe){
							window.localStorage.setItem("rememberMe", true);
							window.localStorage.setItem("username", email_global);
							window.localStorage.setItem("password", password_global);
						}

						window.localStorage.setItem("token", data.object.token);
						setCookie('sterckx-token', data.object.token);

						dispatch(setUserData(data.object))

						const role = data.object.role;
						if(role) {
							const fd_token = getFitdocTokenByRole(role);
							setCookie('fitdoc-token', fd_token);
						}

						if(window.localStorage.getItem("username")){
							window.localStorage.setItem("login-"+window.localStorage.getItem("username"), true);
						}
						else{
							window.localStorage.setItem("username", email_global);
							window.localStorage.setItem("login-"+email_global, true);
						}
						
						window.sessionStorage.setItem("user_data", JSON.stringify(data.object));

						if(data.object.language === "N"){navigate("Portaal");}
						else if(data.object.language === "F"){navigate("Portail");}
						else{navigate("Portal");}
						
						window.localStorage.removeItem("login_username")
						//setLoggedIn(true);
					}
					else{
						if(data.errorcode === 108 && data.message.charAt(0) === 'C'){ 
							//console.log(data.message); 
							setwhite_overlayLR(false);
							setwhite_overlay(false);
							setShowLoader(false);
							toast.error("We're under maintenance...")
							return; 
						}
						// Qastan.addLog({
						// 	"level":Qastan.level.Error,
						// 	"type":Qastan.type.Navigation,
						// 	"details": {
						// 		"title": "Login",
						// 		"description": "User failed to log in",
						// 		"eventtype": "onlogin",
						// 	}
						// })

						console.log(data);
						setwhite_overlay(false);
						setShowError(true);
						seterror(data);
					}
					}
				)
	}

	useEffect(()=>{
		let transitionClasses = generalHelper.classNames({
			[styles.form_section_down]: true,
			[styles.form_section_scaleDown]: false
		});
		setTransClasses(transitionClasses);

		if(window.location.href.split("/")[window.location.href.split("/").length - 1] !== 'admin'){
			if(window.localStorage.getItem("username") && window.localStorage.getItem("password")){
				const authenticateUserData = {
					"username": window.localStorage.getItem("username"),
					"password": window.localStorage.getItem("password")
				}

				handleAuthenticateuser(authenticateUserData)


			}
		}

		if(window.localStorage.getItem("login_username")){
			setEmail(window.localStorage.getItem("login_username"))
		}
		
	}, [])

	let btnLoginClasses = generalHelper.classNames({
		[styles.btn_general]: true
	});

	
	const handleLogin = () =>{
		// Qastan.addLog({
		// 	"level":Qastan.level.Info,
		// 	"type":Qastan.type.User_action,
		// 	"details": {
		// 		"title": "Login",
		// 		"description": "User tried to login",
		// 		"eventtype": "onlogin",
		// 	}
		// })

		setwhite_overlayLR(false);
		setwhite_overlay(true);
		if(typeLogin === "admin"){
			if(email === "root" && password === "root"){
				loggedInLogin(true);
				window.localStorage.setItem("active_navigation_item", "Dashboard")
			}
			return
		}
		let errors = 0;
		if( email.length === 0 || !emailRegex.test(email) ){
			errors++;
		}

		if( password.length === 0 ){
			errors++;
		}

		if( errors === 0 ){
			let transitionClasses = generalHelper.classNames({
				[styles.form_section_down]: true,
				[styles.form_section_scaleDown]: true
			});
			setTransClasses(transitionClasses);

			setTimeout(function(){
				setShowLoader(true);
			},450);

			window.localStorage.setItem("login_username", email);

			// FETCH - VROEGER AJAX CALL
			const authenticateUserData = {
				"username": email.toLocaleLowerCase(),
				"password": password
			}

			handleAuthenticateuser(authenticateUserData)

		}else{
			let transitionClasses = generalHelper.classNames({
				[styles.form_section_down]: true,
				[styles.form_section_scaleDown]: true
			});
			setTransClasses(transitionClasses);
			setTimeout(function() {
				setwhite_overlay(false);
				seterror({"errorcode":104, "message": "Inputfields were not correct", "object": ''})
				setShowError(true);	
			}, 300)
			
		}
	}

	const handleForgotPassword = () =>{
		setwhite_overlay(true);

		setTimeout(function(){
			setwhite_overlay(false);
			setwhite_overlayLR(true);

			setshowPasswordForgot(false);
			setShowLoader(true);
			const passwordRequestData = {
				"email": emailPWForgot.toLocaleLowerCase()
			}

			fetch(process.env.REACT_APP_SERVER_LINK+"passwordRequest?email="+passwordRequestData.email, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json'
				},
			}).then(
				res => res.json()
			).then(
				data => {
					console.log(data);
					if(data.errorcode === 0){
						setwhite_overlay(true);

						setTimeout(function(){
							setwhite_overlay(false);
							setwhite_overlayLR(true);
							setShowEmailSent(true);
						}, 300)
						
					}
					else{
						setShowError(true);
						seterror(data);
						
					}
				}
			)
		}, 300)	
	}

	const closeError = () =>{
		setwhite_overlay(true);

		setTimeout(function(){
			setwhite_overlay(false);
			setShowError(false); 
			setShowLoader(false); 
			setTransClasses('');
			setwhite_overlayLR(true);
		}, 300)
	}

	const handleClickForgotPassword = () =>{
		// Qastan.addLog({
		// 	"level":Qastan.level.Info,
		// 	"type":Qastan.type.User_action,
		// 	"details": {
		// 		"title": "Reset password clicked",
		// 		"description": "User viewed reset password page",
		// 		"eventtype": "onresetpassword",
		// 	}
		// })

		setwhite_overlay(true);
		setwhite_overlayLR(false);

		setTimeout(function(){
			setshowPasswordForgot(true);
			setwhite_overlayLR(true);
			setwhite_overlay(false);
		}, 300)
	}

	const handleClickBackToStart = () =>{
		setwhite_overlay(true);
		setwhite_overlayLR(false);

		setTimeout(function(){
			setshowPasswordForgot(false)
			setwhite_overlay(false);
		}, 300)
	}

	return (

		<>
		<Toaster />
		{!loggedIn ?
		<div className={login_styles.login_main}>
			{(!showLoader && !showError && !showPasswordForgot) ?
			<>
				{white_overlay && <div className={login_styles.white_overlayRL}></div>}
				{white_overlayLR && <div className={login_styles.white_overlayLR}></div>}
				<div className={login_styles.login_screen} onKeyPress={(e) => e.key === 'Enter' && handleLogin()}>
					<h1 className={login_styles.title}>{title ? title : "Log in"}</h1>
					<div style={{width:"100%"}}>
						<div><Inputfield value={email} type="email" placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Login.email_placeholder ? content_state[ReactSession.get("language")].Login.email_placeholder : "E-mail") : "E-mail"} onChange={(e)=>{setEmail(e.currentTarget.value); email_global=(e.currentTarget.value)}} autofocus/></div>
						<div style={{marginTop:"2rem"}}><Inputfield type="password" placeholder={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Login.password_placeholder ? content_state[ReactSession.get("language")].Login.password_placeholder : "Password") : "Password"} onChange={(e)=>{setPassword(e.currentTarget.value); password_global=(e.currentTarget.value)}}/></div>
						<button className={login_styles.forgot_password} onClick={()=>{handleClickForgotPassword()}} style={{backgroundColor:"transparent", border:"none", cursor:"pointer", color:"gray", marginTop:"1rem", fontSize:".85rem", position:"absolute", right:"0"}}>{content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Login.forgotpassword_label ? content_state[ReactSession.get("language")].Login.forgotpassword_label : "Forgot password?") : "Forgot password?"}</button>
					</div>
					<div className={login_styles.login_button} style={{display:"flex", alignItems:"center", justifyContent:"space-between", marginTop:"4rem"}}>
						<div><Checkbox data={[content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Login.rememberme_label ? content_state[ReactSession.get("language")].Login.rememberme_label : "Remember me") : "Remember me"]} size="small" onChange={(val)=>{rememberMe = val}}/></div>
						<div style={{ textAlign:"center"}}><Button value={content_state[ReactSession.get("language")] ? (content_state[ReactSession.get("language")].Login.login_button ? content_state[ReactSession.get("language")].Login.login_button : "Login") : "Login"} onClick={()=>handleLogin()}/></div>
					</div>
				</div>
			</>
			:
			(
				showError ? 
				<>
				{white_overlay && <div className={login_styles.white_overlayRL}></div>}
				<div className={login_styles.white_overlayLR}></div>
				<FormError error={error} transition={true} titleVisible={true} tryAgain={()=>{closeError()}}/>
				</>
				:
				(showPasswordForgot ?
				<>
				{white_overlay && <div className={login_styles.white_overlayRL}></div>}
				{white_overlayLR && <div className={login_styles.white_overlayLR}></div>}
				<div className={transClasses} onKeyPress={(e) => e.key === 'Enter' && handleForgotPassword()}>
					<button className={login_styles.backButton} onClick={()=>{handleClickBackToStart()}}><div className={login_styles.backIcon}><IconArrow color={variable_styles.colors.color_primary}/></div><span>Terug</span></button>
					<h1 style={{margin:"2rem 0 1rem 0"}}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ForgotPassword ? (content_state[ReactSession.get("language")].ForgotPassword.title ? content_state[ReactSession.get("language")].ForgotPassword.title :  "Forgot your password") : ""}</h1>
					<div style={{width:"100%"}}>
						<Inputfield type="email" placeholder={content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ForgotPassword ? (content_state[ReactSession.get("language")].ForgotPassword.email_placeholder ? content_state[ReactSession.get("language")].ForgotPassword.email_placeholder :  "Email") : ""} onChange={(e)=>setemailPWForgot(e.currentTarget.value)} autofocus/>
					</div>
					<div style={{marginTop:"2rem", textAlign:"center"}}><Button value={content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ForgotPassword ? (content_state[ReactSession.get("language")].ForgotPassword.sendmail_button ? content_state[ReactSession.get("language")].ForgotPassword.sendmail_button :  "Send me an e-mail") : ""} onClick={()=>handleForgotPassword()}/></div>
				</div>
				</>
				: 
				(showEmailSent ?
					<>
					{white_overlay && <div className={login_styles.white_overlayRL}></div>}
					{white_overlayLR && <div className={login_styles.white_overlayLR}></div>}
					<div className={transClasses}>
						<h1 style={{textAlign:"center"}}>{content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ForgotPassword ? (content_state[ReactSession.get("language")].ForgotPassword.emailsent_title ? content_state[ReactSession.get("language")].ForgotPassword.emailsent_title :  "Email sent") : ""}</h1>
						<div style={{marginTop:"2rem", textAlign:"center"}}><Button value={content_state[ReactSession.get("language")] && content_state[ReactSession.get("language")].ForgotPassword ? (content_state[ReactSession.get("language")].ForgotPassword.emailsent_back ? content_state[ReactSession.get("language")].ForgotPassword.emailsent_back :  "To login") : ""} onClick={()=>{setShowEmailSent(false); setShowLoader(false)}}/></div>
					</div>
					</>
				:
					<>
					<div style={{display:"flex", justifyContent:"center"}}>
						<FormLoader/>
					</div>
					</>
				)
				)
			)
			}
			
		</div> 
		:
		<>
			
		</>
		}
		</>
  	);
}